import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/portal/auth/AuthContext';
import { ApiError } from '@/portal/api/client';

const LOGO = '/assets/didiers-logo.svg';

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from || '/portal';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      const msg =
        err instanceof ApiError && err.status === 401
          ? 'Incorrect email/username or password.'
          : err instanceof ApiError && err.status === 0
            ? 'Network error — please check your connection.'
            : 'Sign in failed. Please try again.';
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="portal">
      <div className="pl-login">
        <form className="pl-login-card" onSubmit={onSubmit}>
          <div className="pl-login-head">
            <img src={LOGO} alt="Didier's Patisserie" />
          </div>
          <div className="pl-login-body">
            <h1>Client &amp; Trade Portal</h1>
            <p className="sub">Sign in to browse your collection and build presentations.</p>

            {error && <div className="pl-login-error">{error}</div>}

            <div className="pl-field">
              <label htmlFor="pl-email">Email or username</label>
              <input
                id="pl-email"
                type="text"
                autoComplete="username"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="pl-field">
              <label htmlFor="pl-password">Password</label>
              <input
                id="pl-password"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="pl-btn dark"
              style={{ width: '100%', justifyContent: 'center', padding: '12px' }}
              disabled={busy}
            >
              {busy ? 'Signing in…' : 'Sign in'}
            </button>

            <p className="pl-login-foot">
              Trade access is by invitation. Contact your account manager if you need a login.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
